<template>
  <a
    :href="item.web_url_path"
    class="tw-relative tw-flex tw-bg-cover tw-bg-toptw-bg-gray-200 tw-overflow-hidden tw-rounded-lg lg:tw-rounded-xl tw-no-underline tw-text-white tw-group"
  >
    <img :src="`https://www.musora.com/cdn-cgi/image/width=300,quality=95/${item.coach_card_image}`"
         :alt="`${coachFirstName} ${coachLastName}`"
         class="tw-w-full tw-transition-opacity tw-duration-500"
         :class="[
            item.imageLoaded ? 'tw-opacity-1' : 'tw-opacity-0',
            item.type === 'song' ? 'tw-blur-sm' : ''
         ]"
         loading="lazy"
         :onload="item.imageLoaded = true"
    />
    <!-- Coach Details -->
    <div
      class="tw-flex tw-flex-col tw-mt-auto tw-w-full tw-items-center tw-justify-center tw-h-3/4 tw-px-2 tw-text-center tw-absolute tw-bottom-0 tw-left-0"
      style="background: linear-gradient(180deg, rgba(1, 5, 15, 0) 0%, #01050F 100%);"
    >
      <h3
        class="tw-uppercase tw-font-bebas-neue tw-text-white tw-text-2xl xl:tw-text-3xl xl:tw-leading-none tw-break-all tw-leading-tight md:tw-leading-none tw-mt-auto tw-mb-2 tw-text-center"
      >
        <span>{{ coachFirstName }}</span
        ><br />
        <span v-if="hasLastName">{{ coachLastName }}</span>
      </h3>
      <p class="tw-text-yellow-400 tw-text-xs tw-h-8 tw-leading-snug tw-mb-4 tw-uppercase">{{ coachFocus }}</p>
      <div v-if="item.is_house_coach" class="tw-text-white tw-items-center tw-leading-none tw-text-xs tw-font-bebas-neue tw-absolute tw-bottom-0 tw-w-full tw-flex tw-mb-2 tw-justify-center">
        <musora-icon
            icon-name="whistle-filled"
            height="12"
            class="tw-text-white tw-mr-0.5 tw-w-[16px] tw-leading-none"
        ></musora-icon>
        <span class="tw-mt-1">HOUSE</span>
      </div>
    </div>
  </a>
</template>
<script>
import Mixin from "./_mixin";
import ThemeClasses from "../../mixins/ThemeClasses";
import ContentService from "../../assets/js/Services/content";

export default {
  name: "CoachCatalogueCard",
  mixins: [Mixin, ThemeClasses],
  props: {
    brand: {
      type: String,
      default: () => "drumeo",
    },
  },
  computed: {
    coachFirstName() {
      return this.item.name.split(" ")[0];
    },
    hasLastName() {
      return this.item.name.split(" ").length > 1;
    },
    coachLastName() {
      return this.item.name.substr(this.item.name.indexOf(" ") + 1);
    },
    coachFocus() {
      if(this.item.focus_text) {
        return this.item.focus_text;
      }
      return ''
    },
    themeBgClass() {
      return "tw-bg-" + this.brand;
    },
    themeTextClass() {
      return "tw-text-" + this.brand;
    },
  },
  methods: {
    updateCoachSubscription(id) {
      if (!this.item.current_user_is_subscribed) {
        this.item.current_user_is_subscribed = true;
        ContentService.followCoach({ coachId: id })
          .then(() => {
            const text = `You will now receive updates when ${this.coachFirstName} releases new content!`;
            this.$emit("onShowNotification", {
              text,
            });
          })
          .catch(() => {
            this.item.current_user_is_subscribed = false;
            this.$emit("onShowNotification", {
              error: true,
            });
            console.log("Subscribed did not work");
          });
      } else {
        this.item.current_user_is_subscribed = false;
        ContentService.unfollowCoach({ coachId: id })
          .then(() => {
            const text = `You will no longer receive updates when ${this.coachFirstName} releases new content!`;
            this.$emit("onShowNotification", {
              text,
            });
            // console.log("Unsubscribed to: " + this.coachName);
          })
          .catch(() => {
            this.item.current_user_is_subscribed = true;
            this.$emit("onShowNotification", {
              error: true,
            });
            // console.log("Unubscribed did not work");
          });
      }
    },
  },
};
</script>
